import React from 'react'
import Navbar from '../inc/Navbar'

import { Link } from "react-router-dom";

import ScrollToTop from "react-scroll-to-top";
import kpsmainbuild from "../images/kpsMani Build.png";



function Aboutus() {
    return (
        <div>
            <Navbar />
            <br />
            <br />

            <div className="album py-1">
                <div className="container">
                    <h1> KRISHNAGAR PUBLIC SCHOOL </h1>
                </div>
            </div>
            <div className='cbscschoolnadia'>
                <div className='album py-1'>
                    <div className='container mt-3'>
                        <nav aria-label="breadcrumb">
                            <ol className="breadcrumb">
                                <li style={{ color: "white" }} className="breadcrumb-item"><Link to="/" style={{ color: "darkBLue" }} >Home</Link></li>
                                <li className="breadcrumb-item active" style={{ color: "darkBLue" }} aria-current="page">About us <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-chevron-double-right" viewBox="0 0 16 16">
                                    <path fill-rule="evenodd" d="M3.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L9.293 8 3.646 2.354a.5.5 0 0 1 0-.708" />
                                    <path fill-rule="evenodd" d="M7.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L13.293 8 7.646 2.354a.5.5 0 0 1 0-.708" />
                                </svg></li>
                            </ol>
                        </nav>
                    </div>
                </div>
            </div>
            <ScrollToTop smooth top="100" color="darkgoldenrod"/>
            <br />
            <div className="album py-0">
                <div className="container">

                    <div className="card-body">
                        <div className='welcometext'>
                            <h1 className="card-title mb-0"><b>About us</b></h1>
                            <div className="col-md-2">
                                <hr style={{ color: "#1D4D93" }} />
                            </div>
                        </div>
                        <div className="album py-0">
                            <div className="container">
                                <div className="row">

                                    <div className="col-md-7 mt-3">
                                        <div className='mission'>
                                            <h3 style={{ color: "#1D4D93" }} className='mb-2'>Welcome to <b>Krishnagar Public School, Nadia! </b></h3>
                                           <p style={{color:"#1D4D93"}} className='mb-2'>Dear Visitors,</p>
                                    <p>A warm welcome to Krishnagar Public School!</p>

                                    <p className='justify mb-2'>Founded in 2016 through the visionary efforts of Shri Naresh Chandra Das, KPS stands today as a premier co-educational senior secondary school affiliated with the Central Board of Secondary Education (CBSE), New Delhi. With a blend of state-of-the-art infrastructure, a team of committed and experienced educators, and a progressive, child-centric pedagogical approach, we are proud to guide our students confidently into the 21st century.</p>
                                    <p className='justify mb-1'>At KPS, we place our students at the very heart of all that we do. We believe that education must resonate with the learner’s natural curiosity and potential. Children should be taught in ways that align with how they learn best and not forced to fit into a rigid model of teaching. For us, every child is more than a roll number – they are unique individuals, each with their own strengths, dreams, and promise. It is our responsibility to nurture them with care, compassion, and empathy, so they grow into confident, self-aware, and capable human beings. </p>
                                    <p className='justify mb-1'>Our mission is to help every child discover their own unique potential and to support them in translating their abilities into achievements. Rather than just delivering content, we focus on teaching students how to learn, ensuring they grow into lifelong learners, empathetic citizens, and future-ready leaders.</p>
                                    <p className='justify mb-1'>At KPS, values and attitudes are central to our curriculum. We encourage our students to remain grounded in their cultural roots, embrace national pride, and develop a mindset that’s ready for the global stage. Our teaching strategies are continually updated with cutting-edge pedagogical research, fostering critical 21st-century skills such as adaptability, creativity, collaboration, and entrepreneurial thinking.</p>
                                    <p>As you navigate through this website, we invite you to explore the vibrant ethos, holistic opportunities and enriching experiences that make Krishnagar Public School a truly special place for your child.</p>
                                    <p>We look forward to a meaningful and enduring partnership with you.</p>
                                    <h6 style={{color:"#1D4D93"}}>Warm regards,</h6>
                                    <h6 style={{color:"#1D4D93"}}>Team KPS</h6>
                                        </div>
                                    </div>
                                    <div className="col-md-5 mt-3">
                                        <img src={kpsmainbuild} className="card-img-top" alt="KPS_photo" />

                                    </div>





                                </div>
                            </div>
                        </div>
                        <br />






                    </div>
                </div>
            </div>
            <br />


        </div>
    )
}

export default Aboutus